





















































































































































































































































































































































































































































































































































































































































































import DataUtility from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeSpri } from "@/store/modules/spri";
import { storeUnit } from "@/store/modules/unit";
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import AsesmenGadarMedisSvc from "@/services/AsesmenAwalGadarMedisAltSql";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvas.vue";
import { userModule } from "@/store/modules/user";
import CardOrderPenunjangIgdGroup from "@/components/pemeriksaan/penunjang/CardOrderPenunjangIgdGroup.vue";
import ResepIgdGroup from "@/components/resep/ResepIgdGroup.vue";
import AnamnesisDokter from "@/components/AsesmenAwalGadar/AnamnesisDokter.vue";
import PemeriksaanFisik from "@/components/AsesmenAwalGadar/PemeriksaanFisik.vue";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import PreviewAsesmenPerawatGadarNew from "./PreviewAsesmenGadarPerawatNew.vue";
import { AsesmenAwalGadarMedisRequestParams } from "@/types/asesmen_gawat_darurat";
import moment from "moment";
import AsesmenAwalGadar from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";
import CardRiwayatPenyakitTerdahulu from "@/components/pemeriksaan/rpd/CardRiwayatPenyakitTerdahulu.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import HydrationGuard from "@/mixins/HydrationGuard";

@Component({
  components: {
    DrawingCanvas,
    CardModalTtd,
    CardOrderPenunjangIgdGroup,
    ResepIgdGroup,
    AnamnesisDokter,
    PemeriksaanFisik,
    PreviewAsesmenPerawatGadarNew,
    CardRiwayatPenyakitTerdahulu
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenMedisGadarPage extends Mixins(HydrationGuard) {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop({ default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  @Ref() readonly drawcanv;

  rules = {
    required: value => !!value || "Kolom ini harus terisi"
  };

  saving = false;

  canvasWidth = 650;
  canvasHeight = 440;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id" };
  selectProps = { openOnHover: true, offsetY: true };

  id = null;

  showTglKontrolPicker = false;

  anamnesisId = null;
  anamnesis = null;
  keluhanUtama = null;
  riwayatPenyakitDahulu = null;
  riwayatPenyakitSekarang = null;


  fisikId = null;
  fisikImage = null;
  fisikKepala = null;
  fisikLeher = null;
  fisikDada = null;
  fisikParu = null;
  fisikJantung = null;
  fisikPerut = null;
  fisikGenital = null;
  fisikEktrimitaAtas = null;
  fisikEktrimitaBawah = null;
  fisikTubuhBelakang = null;

  addDbn(field) {
    if (this.readOnly || !this.canEditFull) return;
    if (!this[field]) {
      this[field] = "";
      this[field] = this[field].concat(" Dalam batas normal").trim();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  diagnosisKerja = null;
  diagnosisTambahan = null;
  terapiTL = null;

  terapiPlan = null;
  terapi = null;
  terapiTime = null;

  konsulan: number[] = [];
  caraPulang = null;
  kondisiPulang = null;
  unitKontrol = null;
  tujuanRujukan = null;
  alasanRujukan = null;
  unitRanap = null;
  catatan = null;
  observasiJam = null;
  alasanPenundaanLayanan = null;
  alasanRujukanText = null;
  unitTujuanRujukan = null;

  waktuMeninggal = null;
  tglKontrol = null;

  dokter = null;
  dokterPenerima = null;
  dokterPenerimaNamaTersimpan = null;
  dokterPenerimaPpdsTersimpan: string | null = null;
  dpjpTersimpan = null;
  dpjpSigned = false;
  modalTtd = false;
  signing = false;

  searchStringFaskes = "";
  faskesList = [];

  imageUrl = null;

  orderItemsLab = [];

  caraPulangOptions = [
    { id: 1, name: "Pulang" },
    { id: 2, name: "Dirujuk" },
    { id: 3, name: "Pulang Paksa" },
    { id: 4, name: "Meninggal" },
    { id: 5, name: "Rawat Inap" }
  ];
  kondisiPulangOptions = [
    { id: 1, name: "Membaik" },
    { id: 2, name: "Masih Sakit" }
    // { id: 3, name: "Meninggal" },
  ];
  alasanRujukanOptions = [
    { id: 1, name: "Sub-spesialistik" },
    { id: 2, name: "Fasilitas" },
    { id: 3, name: "Tempat Penuh" },
    { id: 4, name: "Permintaan Sendiri/ Keluarga" },
    { id: 5, name: "Lainnya" }
  ];
  terapiTLOptions = [
    { id: 1, name: "Preventif" },
    { id: 2, name: "Kuratif" },
    { id: 3, name: "Paliatif" },
    { id: 4, name: "Rehabilitatif" }
  ];

  get userState() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get unitRalan() {
    return storeUnit.unitPagi;
  }

  get listUnitRanap() {
    return storeUnit.unitRanap;
  }

  get showUnitKontrol() {
    return (
      this.caraPulang === 1 &&
      !!this.kondisiPulang &&
      [1, 2].includes(this.kondisiPulang)
    );
  }

  @Watch("showUnitKontrol")
  changedShowUnitKontrol(val) {
    if (this.hydrating) return;
    if (!val) this.unitKontrol = null;
  }

  get suratRujukan() {
    return storeRujukan.rujukan;
  }

  get isSuratRujukanExist() {
    return this.suratRujukan.length;
  }

  get spri() {
    return storeSpri.spri;
  }

  get isSpriExist() {
    return this.spri.length;
  }

  get tandaVital() {
    return SurveyPrimerIgdStore.asesmen?.id
      ? SurveyPrimerIgdStore.asesmen.content.tanda_vital
      : {
          tensi: "-",
          nadi: "-",
          nafas: "-",
          suhu: "-",
          saturasi: "-"
        };
  }

  get riwayatKesehatan() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatKesehatan
      : {
          alergi: "-",
          obat: "-",
          penyakitLalu: "-",
          makanTerakhir: "-",
          lain: "-"
        };
  }

  get riwayatObstetri() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatObstetri
      : {
          riwayat: "-",
          g: "-",
          p: "-",
          a: "-",
          hpht: "-",
          hpl: "-",
          palpasi: "-",
          tfu: "-",
          tbj: "-",
          his: "-",
          djj: "-",
          panggul: "-",
          vt: "-",
          lla: "-",
          tb: "-",
          bb: "-",
          kb: "-",
          kbDescription: "-"
        };
  }

  get showButtonToSpri() {
    return this.id && !this.isSpriExist;
  }

  get showButtonToRujukan() {
    return this.id && !this.isSuratRujukanExist;
  }

  get storeAsesmenMedis() {
    return AsesmenGadarMedisStore;
  }

  get storeAsesmenPerawat() {
    return AsesmenKeperawatanGadarStore;
  }

  get stateUser() {
    return userModule.user;
  }

  @Watch("requestParams", { deep: true })
  changeRequestParams(val) {
    this.storeAsesmenMedis.SET_INPUT_FIELDS(val);
  }

  get requestParams(): AsesmenAwalGadarMedisRequestParams {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser.unit_id,
      anamnesis: {
        id: this.anamnesisId,
        keluhan_utama: this.keluhanUtama,
        riwayat_penyakit_sekarang: this.riwayatPenyakitSekarang,
        riwayat_penyakit_dahulu: this.riwayatPenyakitDahulu
      },
      fisik: {
        id: this.fisikId,
        kepala: this.fisikKepala,
        leher: this.fisikLeher,
        dada: this.fisikDada,
        paru: this.fisikParu,
        jantung: this.fisikJantung,
        perut: this.fisikPerut,
        genital: this.fisikGenital,
        ektrimita_atas: this.fisikEktrimitaAtas,
        ektrimita_bawah: this.fisikEktrimitaBawah,
        tubuh_belakang: this.fisikTubuhBelakang,
        pemeriksaan_image: this.fisikImage
      },
      diagnosis_kerja: this.diagnosisKerja,
      diagnosis_tambahan: this.diagnosisTambahan,
      terapi_tl: this.terapiTL,
      terapi_rencana_text: this.terapiPlan,
      terapi_text: this.terapi,
      terapi_waktu_text: this.terapiTime,
      konsulan_dokter: this.konsulan,
      // konsulan: [
      //   {
      //     dokter_id: 428,
      //     konsul_at: "2022-11-11 10:10:11",
      //     advice: "advice 1"
      //   },
      //   {
      //     dokter_id: 429,
      //     konsul_at: "2022-11-11 10:10:12",
      //     advice: "advice2"
      //   }
      // ],
      pemulangan_id: this.caraPulang,

      kondisi_pulang_id: this.kondisiPulang,
      kontrol_unit_id: this.unitKontrol,
      tgl_kontrol: this.tglKontrol,

      faskes_rujukan_id: this.tujuanRujukan,
      unit_rujukan: this.unitTujuanRujukan,
      alasan_rujukan: this.alasanRujukan,
      alasan_rujukan_text: this.alasanRujukanText,

      bangsal_unit_id: this.unitRanap,
      observasi: this.observasiJam,
      penundaan_pelayanan: this.alasanPenundaanLayanan,

      waktu_meninggal: this.formatedWaktuMeninggal,

      catatan_lain: this.catatan,
      dpjp_id: this.dokter
    };
  }

  get pemulanganParams() {
    return {
      pemulangan_id: this.caraPulang,
      kondisi_pulang_id: this.kondisiPulang,
      kontrol_unit_id: this.unitKontrol,
      tgl_kontrol: this.tglKontrol,
      faskes_rujukan_id: this.tujuanRujukan,
      unit_rujukan: this.unitTujuanRujukan,
      alasan_rujukan: this.alasanRujukan,
      alasan_rujukan_text: this.alasanRujukanText,
      bangsal_unit_id: this.unitRanap,
      observasi: this.observasiJam,
      penundaan_pelayanan: this.alasanPenundaanLayanan,
      waktu_meninggal: this.formatedWaktuMeninggal,
      catatan_lain: this.catatan,
      konsulan_dokter: this.konsulan,
      dpjp_id: this.dokter
    };
  }

  get tensiText() {
    if (this.tandaVital?.tensi.length > 1) {
      const { sistole, diastole } = this.tandaVital.tensi;

      return sistole + (sistole && diastole ? "/" : "") + diastole;
    } else {
      return "-";
    }
  }

  get riwayatKb() {
    return AsesmenKeperawatanGadarStore.asesmen?.content?.riwayatObstetri.kb
      ?.name;
  }

  get canSignDpjp(): boolean {
    return (
      !!this.id &&
      !this.dpjpSigned &&
      this.userState.profesi == "Dokter" &&
      (!this.dpjpTersimpan || this.dpjpTersimpan == this.userState.id)
    );
  }

  get isDokter(): boolean {
    return this.userState.profesi == "Dokter";
  }

  get isPenerima(): boolean {
    return (
      !this.id ||
      !this.dokterPenerima ||
      this.dokterPenerima == this.userState.id
    );
  }

  get isDpjp(): boolean {
    return !!this.dpjpTersimpan && this.dpjpTersimpan == this.userState.id;
  }

  get slotDpjpKosong(): boolean {
    return !this.dpjpTersimpan;
  }

  get canEditFull(): boolean {
    return this.isDokter && !this.readOnly && this.isPenerima;
  }

  get canEditPemulangan(): boolean {
    return (
      this.isDokter &&
      !this.readOnly &&
      (this.isPenerima || this.isDpjp || this.slotDpjpKosong)
    );
  }

  get canDelete(): boolean {
    return this.isDokter && !this.readOnly && this.isPenerima;
  }

  get canSave(): boolean {
    return this.canEditFull || this.canEditPemulangan;
  }

  get terkunci(): boolean {
    return this.busy || this.saving || this.signing;
  }

  get dokterPenerimaNama() {
    if (this.dokterPenerimaNamaTersimpan)
      return this.dokterPenerimaNamaTersimpan;

    return this.isDokter ? `${this.userState.nama}` : "-";
  }

  get pesanGerbang(): string {
    if (this.readOnly) return "";

    if (!this.isDokter) {
      return "Asesmen medis hanya dapat diisi oleh dokter.";
    }

    if (this.canEditFull) return "";

    const nama = this.dokterPenerimaNamaTersimpan || "dokter penerima";

    if (this.canEditPemulangan) {
      return `Bagian atas hanya dapat diisi oleh ${nama} selaku dokter penerima IGD. Anda dapat melengkapi bagian Pemulangan.`;
    }

    return `Asesmen ini diisi oleh ${nama} selaku dokter penerima IGD dan DPJP-nya sudah ditentukan. Anda hanya dapat melihat isinya.`;
  }

  get formatedWaktuMeninggal() {
    return this.waktuMeninggal
      ? moment(this.waktuMeninggal).format("YYYY-MM-DD HH:mm:ss")
      : null;
  }

  async mounted() {
    this.getFaskesList();

    await this.getAsesmenMedis();

    this.refreshIsianKeperawatan();

    storeSpri.act_spri_on_reg(this.register);
  }

  refreshIsianKeperawatan() {
    SurveyPrimerIgdStore.getByRegister(this.register);
    AsesmenKeperawatanGadarStore.getByRegister(this.register);
  }

  getFaskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.faskesList = faskes;
    });
  }

  async signDpjp(password) {
    if (!this.canSignDpjp || this.signing) return;

    this.signing = true;

    try {
      const resp = await AsesmenGadarMedisSvc.signDpjp(this.id, password);

      if (resp?.data?.status == 1) {
        appModule.NoticeDelay(resp.data.message);
        this.modalTtd = false;

        this.dpjpSigned = true;

        if (!this.dpjpTersimpan) {
          this.dpjpTersimpan = this.userState.id;

          if (!this.dokter) this.dokter = this.userState.id;
        }
      } else {
        appModule.sendErrorAlert(resp?.data?.message || "Gagal TTD DPJP");
      }
    } catch (e) {
      // 
    } finally {
      this.signing = false;
    }
  }

  cekIsianWajib(): boolean {
    if (!this.keluhanUtama) {
      appModule.sendErrorAlert("Keluhan Utama wajib diisi sebelum menyimpan.");
      return false;
    }

    if (this.dokter && !this.diagnosisKerja) {
      appModule.sendErrorAlert(
        "Diagnosis Kerja wajib diisi bila DPJP sudah dipilih."
      );
      return false;
    }

    if (this.dokter && !this.caraPulang) {
      appModule.sendErrorAlert(
        "Cara Pulang wajib dipilih bila DPJP sudah dipilih."
      );
      return false;
    }

    return true;
  }

  async save() {
    if (this.readOnly || this.terkunci) return;
    if (!this.canSave) {
      appModule.sendErrorAlert(
        this.pesanGerbang || "Asesmen medis hanya dapat diisi oleh dokter."
      );
      return;
    }

    const jalurPenuh = !this.id || this.canEditFull;

    if (jalurPenuh && !this.cekIsianWajib()) return;

    this.saving = true;

    try {
      let sendRequest;

      if (!this.id) {
        sendRequest = AsesmenGadarMedisSvc.create(this.requestParams);
      } else if (this.canEditFull) {
        sendRequest = AsesmenGadarMedisSvc.update(this.id, this.requestParams);
      } else {
        sendRequest = AsesmenGadarMedisSvc.updatePemulangan(
          this.id,
          this.pemulanganParams
        );
      }

      const resp = await sendRequest;

      if (resp.data?.status == 1) {
        appModule.NoticeDelay("Berhasil Simpan Asesmen Medis");

        await this.getAsesmenMedis();
      } else {
        appModule.sendErrorAlert(
          resp.data?.message || "Gagal Simpan Asesmen Medis"
        );
      }
    } catch (e) {
      //
    } finally {
      this.saving = false;
    }
  }

  remove() {
    const q = confirm("Hapus Asesmen Medis?");

    if (q) {
      this.deleteData();
    }
  }

  async deleteData() {
    const del = await AsesmenGadarMedisSvc.destroy(this.id);

    if (del?.status == 1) {
      appModule.NoticeDelay("Berhasil Hapus Asesmen Survey Primer");

      this.getAsesmenMedis();
    } else {
      alert("ada kesalahan dalam menghapus data");
    }
  }

  print() {
    AsesmenAwalGadar.printByRegister(this.register);
  }

  async getAsesmenMedis() {
    const reg = this.register;

    await this.hydrate(async () => {
      await this.storeAsesmenMedis.getByRegister(reg);

      if (reg !== this.register) return;

      const data = this.storeAsesmenMedis.asesmen;

      if (data) {
        const ctn = data.content;

        this.id = data.id;

        this.anamnesisId = ctn.anamnesis?.id;
        this.keluhanUtama = ctn.anamnesis?.keluhanUtama;
        this.riwayatPenyakitDahulu = ctn.anamnesis?.riwayatPenyakitDahulu;
        this.riwayatPenyakitSekarang = ctn.anamnesis?.riwayatPenyakitSekarang;

        // // this.fisikImage =
        this.fisikId = ctn.fisik?.id;
        this.fisikKepala = ctn.fisik?.kepala;
        this.fisikLeher = ctn.fisik?.leher;
        this.fisikDada = ctn.fisik?.dada;
        this.fisikParu = ctn.fisik?.paru;
        this.fisikJantung = ctn.fisik?.jantung;
        this.fisikPerut = ctn.fisik?.perut;
        this.fisikGenital = ctn.fisik?.genital;
        this.fisikEktrimitaAtas = ctn.fisik?.ektrimitaAtas;
        this.fisikEktrimitaBawah = ctn.fisik?.ektrimitaBawah;
        this.fisikTubuhBelakang = ctn.fisik?.tubuhBelakang;
        this.fisikImage = ctn.fisik?.image_url;

        // setTimeout(() => {
        //   this.drawcanv.saveImage();
        // }, 1000);

        this.diagnosisKerja = ctn.diagnosis?.kerja;
        this.diagnosisTambahan = ctn.diagnosis?.tambahan;

        this.terapiTL = this.parseToInt(ctn.terapi?.tl);
        this.terapiPlan = ctn.terapi?.plan;
        this.terapi = ctn.terapi?.terapi;
        this.terapiTime = ctn.terapi?.time;

        // this.konsulan = JSON.parse(ctn.konsulan_dokter);
        this.konsulan = ctn.konsulan_dokter;
        this.caraPulang = this.parseToInt(ctn.tindakLanjut?.caraPulang);
        this.kondisiPulang = this.parseToInt(ctn.tindakLanjut?.kondisiPulang);
        this.unitKontrol = ctn.tindakLanjut?.unitKontrol?.toString();
        this.tglKontrol = ctn.tindakLanjut?.tglKontrol;
        this.tujuanRujukan = ctn.tindakLanjut?.tujuanRujukan?.toString();
        this.unitTujuanRujukan = ctn.tindakLanjut?.unitTujuanRujukan;
        this.alasanRujukan = this.parseToInt(ctn.tindakLanjut?.alasanRujukan);
        this.alasanRujukanText = ctn.tindakLanjut?.alasanRujukanText;
        this.unitRanap = ctn.tindakLanjut?.unitRanap?.toString();
        this.observasiJam = ctn.tindakLanjut?.observasiJam;
        this.alasanPenundaanLayanan = ctn.tindakLanjut?.alasanPenundaanLayanan;
        this.catatan = ctn.tindakLanjut?.catatan;
        this.waktuMeninggal = ctn.tindakLanjut?.waktuMeninggal
          ? new Date(ctn.tindakLanjut.waktuMeninggal)
          : null;

        this.dokter = this.parseToInt(ctn.dokter?.id);
        this.dpjpTersimpan = this.dokter;
        this.dpjpSigned = !!ctn.dokter?.signed;
        this.dokterPenerima = this.parseToInt(ctn.dokterPenerima?.id);
        this.dokterPenerimaNamaTersimpan = ctn.dokterPenerima?.nama ?? null;
        this.dokterPenerimaPpdsTersimpan = ctn.dokterPenerima?.ppds ?? null;
      } else {
        this.clearInput();
      }
    });
  }

  parseToInt(item) {
    return item ? parseInt(item.toString()) : null;
  }

  updateDrawedImage(image) {
    this.fisikImage = image;
  }

  @Watch("caraPulang")
  changeCaraPulang(val) {
    if (this.hydrating) return;
    if (val) {
      if (val == 1) {
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.unitRanap = null;
        this.observasiJam = null;
        this.alasanPenundaanLayanan = null;
        this.waktuMeninggal = null;
      } else if (val == 2) {
        this.kondisiPulang = null;
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.unitRanap = null;
        this.observasiJam = null;
        this.alasanPenundaanLayanan = null;
        this.waktuMeninggal = null;
      } else if (val == 5) {
        this.kondisiPulang = null;
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.waktuMeninggal = null;
      } else if (val == 4) {
        this.kondisiPulang = null;
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.unitRanap = null;
        this.observasiJam = null;
        this.alasanPenundaanLayanan = null;
      } else {
        this.kondisiPulang = null;
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.tujuanRujukan = null;
        this.alasanRujukan = null;
        this.unitRanap = null;
        this.observasiJam = null;
        this.alasanPenundaanLayanan = null;
        this.waktuMeninggal = null;
      }
    }

    // // 1
    // this.kondisiPulang
    // this.unitKontrol
    // this.tglKontrol

    // // 2
    // this.tujuanRujukan
    // this.alasanRujukan

    // // 5
    // this.unitRanap
    // this.observasiJam
    // this.alasanPenundaanLayanan

    // // 4
    // this.waktuMeninggal
  }

  @Ref() elmAlasanRujukanText;

  @Watch("alasanRujukan")
  changedAlasanRujukan(val: number) {
    if (this.hydrating) return;
    if (val === 5) {
      this.$nextTick(() => {
        this.elmAlasanRujukanText.focus();
      });
    } else {
      this.alasanRujukanText = null;
    }
  }

  clearInput() {
    this.id = null;

    this.anamnesisId = null;
    this.anamnesis = null;
    this.keluhanUtama = null;
    this.riwayatPenyakitDahulu = null;
    this.riwayatPenyakitSekarang = null;


    this.fisikId = null;
    this.fisikImage = null;
    this.fisikKepala = "";
    this.fisikLeher = "";
    this.fisikDada = "";
    this.fisikParu = "";
    this.fisikJantung = "";
    this.fisikPerut = "";
    this.fisikGenital = "";
    this.fisikEktrimitaAtas = "";
    this.fisikEktrimitaBawah = "";
    this.fisikTubuhBelakang = "";

    this.diagnosisKerja = null;
    this.diagnosisTambahan = null;
    this.terapiTL = null;

    this.terapiPlan = null;
    this.terapi = null;
    this.terapiTime = null;

    this.konsulan = [];
    this.caraPulang = null;
    this.kondisiPulang = null;
    this.unitKontrol = null;
    this.tujuanRujukan = null;
    this.alasanRujukan = null;
    this.unitRanap = null;
    this.catatan = null;
    this.observasiJam = null;
    this.alasanPenundaanLayanan = null;

    this.dokter = null;
    this.dokterPenerima = null;
    this.dokterPenerimaNamaTersimpan = null;
    this.dokterPenerimaPpdsTersimpan = null;
    this.dpjpTersimpan = null;
    this.dpjpSigned = false;

    this.searchStringFaskes = "";

    this.imageUrl = null;
  }
}
